import { createAction, props } from '@ngrx/store';
import { IFeatureConfig, IProcessProfile, IProfileParams } from '@partners/api';
import { IError } from '@partners/errors';
import { IFlatStage, IRoute, IStage } from '@partners/navigation';
import { TFeature } from '@partners/settings';
import { IShellViewState } from './shell.state';

export class ShellActions {
  static reset = createAction('[Shell] Reset State');

  static updateFeatureConfig = createAction(
    '[Shell] Update Feature Config',
    props<{ featureName: TFeature; featureConfig: IFeatureConfig }>()
  );

  static updateProfileParams = createAction(
    '[Shell] Update Profile Params',
    props<{ params: Partial<IProfileParams> }>()
  );

  static updateProcessProfile = createAction('[Shell] Update Profile', props<{ profile: IProcessProfile }>());

  static updateShellView = createAction('[Shell] Update Shell View', props<{ viewState: IShellViewState }>());

  static saveAppError = createAction('[Shell] Save Application Error', props<{ error: IError }>());
  static saveClientProcessId = createAction('[Shell] Save Client Process ID', props<{ clientProcessId: string }>());

  static loadPolicy = createAction('[Shell] Load Policy');
  // static loadPolicySuccess = createAction('[Shell] Load Policy Success', props<{ policy: IPolicy }>());
  static loadPolicyFailure = createAction('[Shell] Load Policy Failure', props<{ error: any }>());

  static updateProgressValue = createAction('[Shell] Update Progress value', props<{ value: number }>());

  static updateAnonymousStage = createAction('[Shell] Update Anonymous Stage', props<{ stage: Partial<IStage> }>());
  static createAnonymousStage = createAction('[Shell] Create Anonymous Stage', props<{ stages?: Partial<IStage>[] }>());

  static updateStages = createAction('[Shell] Update Stages Collection', props<{ stages: IStage[] }>());
  static updateFlatStages = createAction(
    '[Shell] Update Flat Stages Collection',
    props<{ flatStages: IFlatStage[] }>()
  );

  static updateRouteNavigation = createAction(
    '[Shell] Update Navigation Route',
    props<{ previousRoute?: IRoute; currentRoute?: IRoute }>()
  );
  static updateStageNavigation = createAction(
    '[Shell] Update Navigation Stage',
    props<{ previousStage?: IStage; currentStage?: IStage; nextStage?: IStage }>()
  );
}
